<template>
<div class="pt-3">
    <div class="row bg-primary bg-gradient p-2 mb-1">
        <div class="col-4 fw-bold text-white">Warehouse</div>
        <div class="col-4 fw-bold text-center text-white">Qty On Hand</div>
        <div class="col-4 fw-bold text-center text-white">Qty on order</div>
    </div>
    <div class="row p-1" v-for="(row) in WarehouseSOH" :key="row.Warehouse">
        <div class="col-4"><span class="p-4"> {{row.Warehouse}}</span></div>
        <div class="col-4 text-center"><span class="align-middle"> {{qtyFormat(row.QtyOnHand)}} </span></div>
        <div class="col-4 text-center"><span class="align-middle"> {{qtyFormat(row.QtyOnOrder)}}</span></div>
    </div>

</div>
</template>

<script>
export default {
    props: { WarehouseSOH: Array},
    methods:{
    changeInvQuery(Bom){
        this.$store.commit("bomStockCode/setSelectSockCode",Bom.Component)
    },
    qtyFormat(Num){
        return Number(Num).toFixed(3)
    }
  }
}
</script>

<style>

</style>